<div id="layout" class="theme-cyan">
  <app-project-leftmenu></app-project-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Kanban Board</h5>
                  </div>
                  <small class="text-truncate text-muted">Last Update your Board: 29 Aug 2020</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="nav-link text-muted" href="javascript:void(0)" (click)="openModal(template)">Create
                    task</a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="javascript:void(0)CreateTask"
                        href="javascript:void(0)">Create
                        task</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row">
            <div class="col-12 p-0">
              <div class="card border-0 scrum-body d-flex" cdkDropListGroup>

                <!-- board: create -->
                <div class="scrum-board mt-3 px-3 create">
                  <h6><span class="badge bg-secondary">2</span> Create new</h6>
                  <div class="scrum-board-column mt-3" cdkDropList [cdkDropListData]="todo"
                    class="example-list scrum-board-column" (cdkDropListDropped)="drop($event)">
                    <div class="card-body border scrum-task overflow mb-1" *ngFor="let item of todo" cdkDrag>
                      <h6>{{item.title}}</h6>
                      <div class="st-description mt-3 mb-2">{{item.description}}</div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="st-date text-muted">Due 20/04/2020</div>
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar5.jpg" data-bs-toggle="tooltip"
                            data-placement="top" title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar6.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Martin">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- board: in progress -->
                <div class="scrum-board mt-3 px-3 in-progress">
                  <h6><span class="badge bg-secondary">3</span> In progress</h6>
                  <div cdkDropList [cdkDropListData]="inprogress" class="scrum-board-column mt-3"
                    (cdkDropListDropped)="drop($event)" id="in-progress">
                    <div class="card-body border scrum-task overflow mb-1" id="423" *ngFor="let item of inprogress"
                      cdkDrag>
                      <h6>{{item.title}}</h6>
                      <div class="st-description mt-3 mb-2">{{item.description}}</div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="st-date text-muted">Due 20/04/2020</div>
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip"
                            data-placement="top" title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar2.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Sean">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- board: done -->
                <div class="scrum-board mt-3 px-3 done">
                  <h6><span class="badge bg-secondary">2</span> Done</h6>
                  <div cdkDropList [cdkDropListData]="done" class="scrum-board-column mt-3"
                    (cdkDropListDropped)="drop($event)" id="done">
                    <div class="card-body border scrum-task overflow mb-1" *ngFor="let item of done" cdkDrag id="12">
                      <h6>{{item.title}}</h6>
                      <div class="st-description mt-3 mb-2">{{item.description}}</div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="st-date text-muted">Due 20/04/2020</div>
                        <div class="avatar-list avatar-list-stacked">
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip"
                            data-placement="top" title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar8.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar3.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Sean">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>

<!-- create new task popup Default Size -->
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="font-family: 'IBM Plex Sans', sans-serif;">Create task</h4>

  </div>
  <div class="modal-body" style="font-family: 'IBM Plex Sans', sans-serif;">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Task title</label>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Enter task title">
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-group">
          <label>Assignee to</label>
          <div class="input-group">
            <select class="form-control">
              <option>Select</option>
              <option>Jason Porter</option>
              <option>Denise Elliott</option>
              <option>Rose Coke</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-group">
          <label>Due date</label>
          <div class="input-group">
            <input data-provide="datepicker" data-date-autoclose="true" class="form-control"
              placeholder="Select due date" bsDatepicker>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label>Description</label>
          <div class="input-group">
            <textarea rows="4" class="form-control no-resize" placeholder="Task description..."></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="font-family: 'IBM Plex Sans', sans-serif;">
    <button type="button" class="btn btn-default" (click)="modalRef.hide()">Close</button>
    <button type="button" class="btn btn-primary theme-bg gradient" style="background-color: #21AA93;">Add</button>
  </div>
</ng-template>
<!-- create new task popup Default Size -->]